import React from 'react'

const IconSelectArrow = ({ isClicked = false }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <mask
        id='mask0_16929_32717'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_16929_32717)'>
        <path
          d='M9.99979 13.0898L5.57666 8.6667L6.16645 8.0769L9.99979 11.9102L13.8331 8.0769L14.4229 8.6667L9.99979 13.0898Z'
          fill='#686867'
        />
      </g>
    </svg>
  )
}

export default IconSelectArrow
